import Page from "../Page";
import PartnerList from "./partners/PartnerList";

export const OCPIOnboarding = () => {
  return (
    <Page 
      title="OCPI Partners | Smart-CMS"
      actions={[
        { path: "/ocpi/partners/onboard", text: "Add Partner", icon: "eva:plus-fill" },
      ]}
    >
      <PartnerList />
    </Page>
  );
};

export default OCPIOnboarding;